/* TTM podcast episode enhancements — v3 transcript-compatible patch.
   Accepts both legacy .podcast-transcript__body markup and v2 sync-kit direct
   .transcript-segment children. Safe to re-run in Shopify's theme editor. */
(function () {
  function parseStamp(value) {
    var parts = String(value || '').trim().split(':').map(Number);
    if (!parts.length || parts.some(function (n) { return Number.isNaN(n); })) return null;
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    if (parts.length === 2) return parts[0] * 60 + parts[1];
    return parts[0];
  }

  function openTranscript(container) {
    if (container && container.tagName === 'DETAILS') container.open = true;
  }

  function init(root) {
    if (!root || root.dataset.ttmEpisodeInitialized === 'true') return;
    root.dataset.ttmEpisodeInitialized = 'true';

    var transcript = root.querySelector('.podcast-transcript');
    if (!transcript) return;

    /* Legacy theme shape: .podcast-transcript > .podcast-transcript__body
       Sync-kit shape:      .podcast-transcript > p.transcript-segment */
    var body = transcript.querySelector('.podcast-transcript__body') || transcript;
    var paras = Array.prototype.slice.call(body.querySelectorAll('.transcript-segment'));
    if (!paras.length) paras = Array.prototype.slice.call(body.querySelectorAll('p'));
    if (!paras.length) return;

    var placeholder = root.getAttribute('data-transcript-search-placeholder') || 'Search this transcript';
    var aria = root.getAttribute('data-transcript-search-label') || placeholder;
    var singular = root.getAttribute('data-transcript-match-singular') || 'passage';
    var plural = root.getAttribute('data-transcript-match-plural') || 'passages';

    var bar = document.createElement('div');
    bar.className = 'ttm-transcript-tools';
    bar.innerHTML = '<input type="search" class="ttm-transcript-search"><span class="ttm-transcript-count" role="status"></span>';
    var input = bar.querySelector('input');
    input.placeholder = placeholder;
    input.setAttribute('aria-label', aria);

    if (body === transcript) {
      var summary = transcript.querySelector(':scope > summary');
      if (summary && summary.nextSibling) transcript.insertBefore(bar, summary.nextSibling);
      else if (summary) transcript.appendChild(bar);
      else transcript.insertBefore(bar, transcript.firstChild);
    } else {
      body.parentNode.insertBefore(bar, body);
    }

    var count = bar.querySelector('.ttm-transcript-count');
    var originals = paras.map(function (p) { return p.innerHTML; });

    function reset() {
      paras.forEach(function (p, i) { p.innerHTML = originals[i]; p.hidden = false; });
      count.textContent = '';
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q.length < 3) return reset();
      var re = new RegExp('(' + q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      var hits = 0;
      paras.forEach(function (p, i) {
        var original = originals[i];
        var match = re.test(p.textContent);
        re.lastIndex = 0;
        p.hidden = !match;
        p.innerHTML = match ? original.replace(re, '<mark>$1</mark>') : original;
        if (match) hits++;
      });
      count.textContent = hits + ' ' + (hits === 1 ? singular : plural);
    });

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-ttm-jump]');
      if (!link) return;
      e.preventDefault();
      openTranscript(transcript);

      var raw = link.getAttribute('data-ttm-jump') || '';
      var seconds = parseStamp(raw);
      var target = null;

      /* Prefer sync-kit deterministic anchors, e.g. #transcript-t-252. */
      if (seconds !== null) {
        target = document.getElementById('transcript-t-' + Math.floor(seconds));
      }
      if (!target && seconds !== null) {
        target = paras.filter(function (p) {
          var stamp = p.querySelector('[data-seconds]');
          return stamp && Number(stamp.getAttribute('data-seconds')) === Math.floor(seconds);
        })[0];
      }
      if (!target) {
        var stampText = raw.length >= 5 ? raw.slice(-5) : raw;
        target = paras.filter(function (p) { return p.textContent.indexOf(stampText) > -1; })[0];
      }

      if (target) {
        if (target.id) history.replaceState(null, '', '#' + target.id);
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    });

    if (location.hash && location.hash.indexOf('#transcript') === 0) openTranscript(transcript);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ttm-episode').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
